import { render, staticRenderFns } from "./image-group.vue?vue&type=template&id=3a2eb04f&scoped=true"
import script from "./image-group.vue?vue&type=script&lang=js"
export * from "./image-group.vue?vue&type=script&lang=js"
import style0 from "./image-group.vue?vue&type=style&index=0&id=3a2eb04f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a2eb04f",
  null
  
)

export default component.exports